import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { applyPosUiPreferences, readPosUiPreferences } from "@/pos/settingsRuntime";

const METAMASK_EXTENSION_ORIGIN = "chrome-extension://nkbihfbeogaeaoehlefnkodbefgpgknn";

function getSuppressedRuntimeText(value) {
  return [
    typeof value === "string" ? value : null,
    value?.message,
    value?.stack,
    value?.filename,
    value?.reason?.message,
    value?.reason?.stack,
  ]
    .filter(Boolean)
    .join("\n");
}

function isMetaMaskExtensionRuntimeError(value) {
  const text = getSuppressedRuntimeText(value);
  return text.includes("Failed to connect to MetaMask") && text.includes(METAMASK_EXTENSION_ORIGIN);
}

if (process.env.NODE_ENV === "development") {
  window.addEventListener(
    "error",
    (event) => {
      if (!isMetaMaskExtensionRuntimeError(event) && !isMetaMaskExtensionRuntimeError(event.error)) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true,
  );

  window.addEventListener(
    "unhandledrejection",
    (event) => {
      if (!isMetaMaskExtensionRuntimeError(event) && !isMetaMaskExtensionRuntimeError(event.reason)) {
        return;
      }

      event.preventDefault();
      event.stopImmediatePropagation();
    },
    true,
  );
}

applyPosUiPreferences(readPosUiPreferences());

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

const isLocalhost =
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1' ||
  window.location.hostname === '::1';

if (isLocalhost && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister().catch(() => {});
      });
    }).catch(() => {});
  });
}

// Register service worker after React has mounted
if ('serviceWorker' in navigator && !isLocalhost) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then(reg => {
        console.log('[SW] Registered, scope:', reg.scope);

        // Prompt the active SW to skip waiting when a new version is available
        reg.addEventListener('updatefound', () => {
          const newWorker = reg.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                newWorker.postMessage({ type: 'SKIP_WAITING' });
              }
            });
          }
        });
      })
      .catch(err => console.warn('[SW] Registration failed:', err));
  });
}
